exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".is-opaque[data-v-29a8c2a8]{background:hsla(0,0%,100%,.4)}.overlay.is-overlay[data-v-29a8c2a8]{display:-webkit-box;display:-ms-flexbox;display:flex}.overlay.is-overlay .overlay-loader[data-v-29a8c2a8]{margin:auto;-webkit-animation:spinAround .5s infinite linear;animation:spinAround .5s infinite linear;border-radius:50%;content:\"\"}.overlay.is-overlay .overlay-loader.is-small[data-v-29a8c2a8]{height:1em;width:1em}.overlay.is-overlay .overlay-loader.is-medium[data-v-29a8c2a8]{width:2em;height:2em}.overlay.is-overlay .overlay-loader.is-large[data-v-29a8c2a8]{width:3em;height:3em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-29a8c2a8","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/enso/bulma/Overlay.vue
// module id = vkuM
// module chunks = 8 25 49 50 53 66